/* ZSportsTech — section-hero.js
   Scoped to #sc-hero. Vanilla JS only, no frameworks.
   Maps to → assets/section-hero.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-hero');
  if (!hero) return;

  /* ── 1. Video bg — pause when off-screen ──────────
     Activates once a <video> element is present inside
     .sc-hero__bg (dropped in from section settings).    */
  var bg  = document.getElementById('sc-hero-bg');

  /* ── 0. Responsive hero media ─────────────────────
     Load the mobile video on phones (≤768px), the desktop
     image otherwise — so neither heavy asset downloads on
     the wrong device. Set once, based on the initial width. */
  if (bg && !bg.querySelector('img, video')) {
    var mobileVideo = bg.getAttribute('data-mobile-video');
    var desktopImg  = bg.getAttribute('data-desktop-img');
    var isMobile    = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile && mobileVideo) {
      var v = document.createElement('video');
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');
      v.setAttribute('loop', '');
      v.setAttribute('autoplay', '');
      v.setAttribute('preload', 'auto');
      v.setAttribute('aria-hidden', 'true');
      v.muted = true; v.loop = true; v.autoplay = true;
      v.src = mobileVideo;
      bg.appendChild(v);
    } else if (desktopImg) {
      var im = document.createElement('img');
      im.src = desktopImg;
      im.setAttribute('alt', '');
      im.setAttribute('role', 'presentation');
      im.setAttribute('aria-hidden', 'true');
      bg.appendChild(im);
    }
  }

  var vid = bg ? bg.querySelector('video') : null;

  if (vid) {
    vid.setAttribute('playsinline', '');
    vid.setAttribute('muted', '');
    vid.muted = true; /* iOS requires programmatic mute */

    /* iOS (Low Power Mode, or in-app browsers like Instagram/WhatsApp) can
       silently block muted autoplay despite every correct attribute here.
       When that happens, retry on the visitor's very first tap/scroll —
       a real user gesture always clears the block, so the video starts
       instead of sitting on iOS's native paused/play-button state. */
    var retryPlay = function () {
      vid.play().catch(function () {});
    };
    var armGestureRetry = function () {
      var events = ['touchstart', 'click', 'scroll'];
      var retryOnce = function () {
        events.forEach(function (evt) { document.removeEventListener(evt, retryOnce); });
        retryPlay();
      };
      events.forEach(function (evt) { document.addEventListener(evt, retryOnce, { passive: true }); });
    };

    if ('IntersectionObserver' in window) {
      var vidObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            vid.play().catch(armGestureRetry);
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.1 });
      vidObs.observe(hero);
    } else {
      vid.play().catch(armGestureRetry);
    }
  }

  /* ── 2. ZAC disc — chatbot launcher ───────────────
     Placeholder: fire a custom event that the Zac SDK
     or a parent theme script can listen to.            */
  var zacBtn = document.getElementById('sc-hero-zac');
  if (zacBtn) {
    zacBtn.addEventListener('click', function () {
      /* Dispatch a namespaced event for the Zac integration */
      var evt = new CustomEvent('zsportstech:zac:open', { bubbles: true });
      hero.dispatchEvent(evt);

      /* Direct SDK hook — wire when Zac is available:
         if (window.ZacChat) window.ZacChat.open();       */
    });
  }

  /* ── 3. Reduced-motion: disable live-dot animation ─ */
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dot = hero.querySelector('.sc-hero__live-dot');
  function applyMotionPref() {
    if (dot) dot.style.animationName = mq.matches ? 'none' : '';
  }
  applyMotionPref();
  if (mq.addEventListener) { mq.addEventListener('change', applyMotionPref); }

}());
